import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { msalInstance } from "@/lib/msalConfig";
import { EventType } from "@azure/msal-browser";

const root = ReactDOM.createRoot(document.getElementById("root"));

// MSAL must be initialized before rendering anything that uses MsalProvider.
msalInstance
    .initialize()
    .then(() => {
        // Ensure an active account is set if there is exactly one.
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
            msalInstance.setActiveAccount(accounts[0]);
        }
        msalInstance.addEventCallback((evt) => {
            if (
                (evt.eventType === EventType.LOGIN_SUCCESS ||
                    evt.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
                evt.payload?.account
            ) {
                msalInstance.setActiveAccount(evt.payload.account);
            }
        });
        return msalInstance.handleRedirectPromise();
    })
    .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("MSAL init failed", err);
    })
    .finally(() => {
        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );
    });
